// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 656 ? "component---src-components-templates-page-tsx" : chunkId) + "-" + {"656":"f3730724fb7753c28470","711":"0b023c7e079ec2162f17","725":"d551b17681c63e83d7a7","739":"24622a2e7ef7dd7080e5"}[chunkId] + ".js";
};